import axios from "axios";

class ServerError extends Error {
    constructor(status, message, retryAfter, data) {
        super(message);
        this.name = "ServerError";
        this.status = status;
        this.retryAfter = retryAfter;
        this.data = data;
    }
}

const STATUS_MESSAGES = {
    429: (retryAfter) =>
        retryAfter
            ? `Too many requests. Try again in ${retryAfter}s.`
            : "Too many requests. Try again shortly.",
};

let unauthorizedHandler = () => false;

function setUnauthorizedHandler(handler) {
    unauthorizedHandler = handler;
}

function handleError(err) {
    const status = err.response?.status;
    if (status === 401 && unauthorizedHandler()) {
        return new Promise(() => {});
    }
    const buildMessage = STATUS_MESSAGES[status];
    if (!buildMessage) {
        throw err;
    }
    const retryAfter =
        parseInt(err.response?.headers?.["retry-after"], 10) || null;
    throw new ServerError(
        status,
        buildMessage(retryAfter),
        retryAfter,
        err.response?.data
    );
}

function pageErrorFrom(err) {
    const status = err.response?.status;
    if (status === 403 || status === 404) {
        return status;
    }
    throw err;
}

function handleResponse(response) {
    return response.data.data;
}

async function fetch(url, options) {
    return axios.get(url, options || {}).catch(handleError);
}

async function create(url, data, options) {
    return axios.post(url, data, options || {}).catch(handleError);
}

async function edit(url, data, options) {
    return axios.put(url, data, options || {}).catch(handleError);
}

async function del(url, options) {
    return axios.delete(url, options || {}).catch(handleError);
}

export {
    ServerError,
    handleError,
    handleResponse,
    pageErrorFrom,
    setUnauthorizedHandler,
    fetch,
    create,
    edit,
    del,
};
